(() => {
  window.addEventListener('load', function () {
    if (window.Shopify && window.Shopify.designMode) { return; }

    const loadAccessibe = function() {
      const s = document.createElement('script');
      const h = document.querySelector('head') || document.body;

      s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
      s.async = true;
      s.onload = function(){
        acsbJS.init({
          statementLink : '',
          footerHtml : '',
          hideMobile : false,
          hideTrigger : true,
          disableBgProcess : false,
          language : 'en',
          position : 'left',
          leadColor : '#231f20',
          triggerColor : '#231f20',
          triggerRadius : '50%',
          triggerPositionX : 'left',
          triggerPositionY : 'center',
          triggerIcon : 'people',
          triggerSize : 'medium',
          triggerOffsetX : 32,
          triggerOffsetY : 0,
          mobile : {
            triggerSize : 'small',
            triggerPositionX : 'left',
            triggerPositionY : 'center',
            triggerOffsetX : 16,
            triggerOffsetY : 0,
            triggerRadius : '50%'
          }
        });

        setupFixedButtons();
        setupAccessibeFooterButton();
      };
      h.appendChild(s);
    };

    // buttons tracked by this script: contact-us / accessibe
    const setupFixedButtons = function() {
      const $footer = document.querySelector('footer');
      // pdp sticky footer
      const $mainAddToCartButton = document.querySelector('.js-main-add-to-cart');
      const $pdpMobileStickyNav = document.querySelector('.sticky-add.js-pdp-sticky-nav');
      // landing page shopper sticky footer
      const $stickyPartnership = document.querySelector('sticky-partnership');

      let stickyHiddenOnLoad = false;
      let $stickyThresholdTarget = null;

      // landing page sticky bars
      const $lpStickyBar = document.querySelector('[lpStickyBar]');
      if ($lpStickyBar && $lpStickyBar.classList.contains('initHidden')) {
        $stickyThresholdTarget = document.querySelectorAll('.page-container .shopify-section').item(parseInt($lpStickyBar.dataset.section) - 1);
        stickyHiddenOnLoad = true;
      }

      // bb sticky progress bar
      const $bbProgressWidget = document.querySelector('.bb-grid__progress');
      const $bbThresholdTarget = document.querySelector('section#freebies');
      if ($bbProgressWidget && $bbThresholdTarget) {
        $stickyThresholdTarget = $bbThresholdTarget;
        stickyHiddenOnLoad = true;
      }

      // article mobile sticky footer
      const $articleHeader = document.querySelector('.js-article-top');
      const $articleMobileStickyFooter = document.querySelector('.js-article-sticky-footer');

      // top header
      const $mainNav = document.querySelector('.header__inner');
      const navHeight = $mainNav.offsetHeight;

      let $buttons = [];

      // setup livechat button
      const setupFixedContactButton = function() {
        // add button markup to page
        let btnContainer = document.createElement('div');
        btnContainer.classList.add('zlivechat');
        document.body.appendChild(btnContainer);

        let btn = document.createElement('button');
        btn.setAttribute('aria-labelledby', 'l-zchat');
        btn.classList.add('zlivechat__btn');
        btn.innerHTML = '<span id="l-zchat" hidden>Open live chat</span><svg style="width: 22px; height: 22px;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g fill="currentColor"><path d="M512 0c282.7776 0 512 229.12 512 511.744a509.6448 509.6448 0 0 1-47.7184 216.0128l44.9536 214.9376c11.5712 55.3984-23.7568 90.7776-79.104 79.0528l-214.7328-45.568a510.2592 510.2592 0 0 1-215.3984 47.36c-282.7776 0-512-229.12-512-511.7952C0 229.12 229.2224 0 512 0z m0 102.4a409.6 409.6 0 1 0 0 819.2c60.416 0 118.784-13.0048 172.2368-37.888l31.0272-14.336 194.6112 41.6256-40.7552-195.328 14.336-30.8736A407.6544 407.6544 0 0 0 921.6 512a409.6 409.6 0 0 0-409.6-409.6z m0 332.8a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m-204.8 0a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z m409.6 0a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z" /></g></svg>';
        if (stickyHiddenOnLoad) {
          btn.classList.add('hidden');
        }

        // btn related event listeners
        btn.addEventListener('click', function() {
          window.location.href = '/pages/contact-us';
        });

        $buttons.push(btn);
        btnContainer.appendChild(btn);
      }();

      const setupFixedAccessibeButton = function() {
        // add button markup to page
        let btnContainer = document.createElement('acsb-button');
        document.body.appendChild(btnContainer);

        let btn = document.createElement('button');
        btn.setAttribute('aria-labelledby', 'l-accessibe');
        btn.classList.add('acsb-button__btn');
        btn.innerHTML = '<span id="l-accessibe" hidden>Open accessiBe: accessibility options, statement and help</span><svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 100 131.3"><g fill="currentColor"><path xmlns="http://www.w3.org/2000/svg" d="M71.6 131.3c1 0 2.1-.3 3.1-.8 3.9-1.8 5.5-6.2 3.6-10.1 0 0-14.3-32.7-16.9-44.7-1-4.2-1.6-15.3-1.8-20.5 0-1.8 1-3.4 2.6-3.9l32-9.6c3.9-1 6.2-5.5 5.2-9.4-1-3.9-5.5-6.2-9.4-5.2 0 0-29.6 9.6-40.3 9.6-10.4 0-39.8-9.4-39.8-9.4-3.9-1-8.3.8-9.6 4.7-1.3 4.2 1 8.6 5.2 9.6l32 9.6c1.6.5 2.9 2.1 2.6 3.9-.3 5.2-.8 16.4-1.8 20.5-2.6 12-16.9 44.7-16.9 44.7-1.8 3.9 0 8.3 3.6 10.1 1 .5 2.1.8 3.1.8 2.9 0 5.7-1.6 6.8-4.4l15.3-31.2L64.8 127c1.3 2.7 3.9 4.3 6.8 4.3z"></path><circle cx="50.3" cy="14.6" r="14.6"></circle></g></svg>';
        btn.dataset.acsbCustomTrigger = "true";
        if (stickyHiddenOnLoad) {
          btn.classList.add('hidden');
        }

        $buttons.push(btn);
        btnContainer.appendChild(btn);
      }();

      const chatScrollObserver = new IntersectionObserver(entries => {
        const bottomOfScreen = window.scrollY + window.innerHeight;

        entries.forEach(({target, isIntersecting}) => {
          const targetTop = target.getBoundingClientRect().top;

          if (target === $mainAddToCartButton) {
            if (!isIntersecting && target.getBoundingClientRect().top < 0 && window.innerWidth < 992) {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('offset')) {
                  btn.style.setProperty('--offsetHeight', `-${$pdpMobileStickyNav.offsetHeight}px`);
                  btn.classList.add('offset');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('offset')) {
                  btn.classList.remove('offset');
                }
              });
            }
          }

          if (target === $articleHeader) {
            let offsetHeight;

            if ($articleHeader && $articleMobileStickyFooter) {
              offsetHeight = $articleMobileStickyFooter.offsetHeight;
            }

            if (!isIntersecting && window.innerWidth < 768) {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('offset')) {
                  btn.style.setProperty('--offsetHeight', `-${offsetHeight}px`);
                  btn.classList.add('offset');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('offset')) {
                  btn.classList.remove('offset');
                }
              });
            }
          }

          if (target === $stickyThresholdTarget) {
            if (isIntersecting) {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('hidden')) {
                  btn.classList.remove('hidden');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('hidden')) {
                  if (targetTop < bottomOfScreen && (targetTop - navHeight) > 0) {
                    btn.classList.add('hidden');
                  }
                }
              });
            }
          }

          if (target === $footer) {
            if (isIntersecting) {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('hidden')) {
                  btn.classList.add('hidden');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('hidden')) {
                  if (!$stickyThresholdTarget || ($stickyThresholdTarget && ($stickyThresholdTarget.getBoundingClientRect().top < bottomOfScreen))) {
                    btn.classList.remove('hidden');
                  }
                }
              });
            }
          }

        });
      }, { rootMargin: `-${navHeight}px 0px 0px 0px` });

      // offset the chat button if mobile sticky item is visible on screen
      if ($mainAddToCartButton && $pdpMobileStickyNav) {
        chatScrollObserver.observe($mainAddToCartButton);
      }

      // offset the chat button if mobile landing sticky item is visible on screen
      if ($articleHeader && $articleMobileStickyFooter) {
        chatScrollObserver.observe($articleHeader);
      }

      // delay visibility if sticky footer is in view and it has a delay
      $stickyThresholdTarget && chatScrollObserver.observe($stickyThresholdTarget);

      // hide button if footer is reached
      chatScrollObserver.observe($footer);

      const handleChatObjectResizes = function() {
        let offsetHeight;

        if ($mainAddToCartButton) {
          if (window.innerWidth >= 992) {
            $buttons.forEach((btn) => {
              if (btn.classList.contains('offset')) {
                btn.classList.remove('offset');
              }
            });
          } else {
            if ($mainAddToCartButton.getBoundingClientRect().top < 0) {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('offset')) {
                  btn.style.setProperty('--offsetHeight', `-${$pdpMobileStickyNav.offsetHeight}px`);
                  btn.classList.add('offset');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('offset')) {
                  btn.classList.remove('offset');
                }
              });
            }
          }
        }

        if ($bbThresholdTarget) {
          // bundle builder progress widget is only sticky on mobile
          if (window.innerWidth >= 880) {
            $buttons.forEach((btn) => {
              if (btn.classList.contains('offset')) {
                btn.classList.remove('offset');
              }
            });
          } else {
            $buttons.forEach((btn) => {
              btn.style.setProperty('--offsetHeight', `-${$bbProgressWidget.offsetHeight - 24}px`);
              btn.classList.add('offset');
            });
          }
        }

        if ($lpStickyBar) {
          offsetHeight = $lpStickyBar.offsetHeight;

          if ($lpStickyBar.classList.contains('visible')) {
            $buttons.forEach((btn) => {
              let dataHeight = btn.dataset.height;

              if (!btn.classList.contains('offset') || !dataHeight || dataHeight !== offsetHeight) {

                btn.dataset.height = offsetHeight;
                btn.style.setProperty('--offsetHeight', `-${offsetHeight + 8}px`);
                btn.classList.add('offset');
              }
            });
          } else {
            $buttons.forEach((btn) => {
              if (btn.classList.contains('offset')) {
                delete btn.dataset.height;
                btn.classList.remove('offset');
              }
            });
          }
        }

        if ($articleHeader || $stickyPartnership) {
          let $trackedObject;

          if ($articleHeader && $articleMobileStickyFooter) {
            $trackedObject = $articleHeader;
            offsetHeight = $articleMobileStickyFooter.offsetHeight;
          } else if ($stickyPartnership) {
            $trackedObject = $stickyPartnership;
            offsetHeight = $stickyPartnership.offsetHeight;
          }

          if (window.innerWidth >= 768 || $trackedObject.classList.contains('closed')) {
            $buttons.forEach((btn) => {
              if (btn.classList.contains('offset')) {
                btn.classList.remove('offset');
              }
            });
          } else {
            const windowHeight = window.innerHeight;
            const trackedObjBox = $trackedObject.getBoundingClientRect();
            let trackedObjInsideY = trackedObjBox.top >= 0 && trackedObjBox.top + trackedObjBox.height <= windowHeight;
            let trackedObjOnBottom = trackedObjBox.top < windowHeight && trackedObjBox.top + trackedObjBox.height > windowHeight;

            if (trackedObjInsideY || trackedObjOnBottom) {
              $buttons.forEach((btn) => {
                if (!btn.classList.contains('offset')) {
                  btn.style.setProperty('--offsetHeight', `-${offsetHeight}px`);
                  btn.classList.add('offset');
                }
              });
            } else {
              $buttons.forEach((btn) => {
                if (btn.classList.contains('offset')) {
                  btn.classList.remove('offset');
                }
              });
            }
          }
        }
      };

      // manual way of triggering redraw of chat button position
      document.addEventListener('livechat:resize', handleChatObjectResizes);

      const chatResizeObserver = new ResizeObserver(handleChatObjectResizes);
      if ($mainAddToCartButton || ($articleHeader && $articleMobileStickyFooter) || $stickyPartnership || $lpStickyBar || $bbProgressWidget) {
        chatResizeObserver.observe($footer);
      }
    };

    const setupAccessibeFooterButton = function() {
      const $footer = document.querySelector('footer');
      if (!$footer) { return; }

      // add button markup to page
      const btnContainer = document.createElement('acsb-footer-button');
      const btnContainerBox = document.createElement('div');
      const btn = document.createElement('button');

      btnContainerBox.classList.add('acsb-button__container');

      btn.setAttribute('aria-labelledby', 'l-accessibe');
      btn.classList.add('acsb-button__btn');
      btn.innerHTML = '<span id="l-accessibe" hidden>Open accessiBe: accessibility options, statement and help</span><svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 100 131.3"><g fill="currentColor"><path d="M71.6 131.3c1 0 2.1-.3 3.1-.8 3.9-1.8 5.5-6.2 3.6-10.1 0 0-14.3-32.7-16.9-44.7-1-4.2-1.6-15.3-1.8-20.5 0-1.8 1-3.4 2.6-3.9l32-9.6c3.9-1 6.2-5.5 5.2-9.4-1-3.9-5.5-6.2-9.4-5.2 0 0-29.6 9.6-40.3 9.6-10.4 0-39.8-9.4-39.8-9.4-3.9-1-8.3.8-9.6 4.7-1.3 4.2 1 8.6 5.2 9.6l32 9.6c1.6.5 2.9 2.1 2.6 3.9-.3 5.2-.8 16.4-1.8 20.5-2.6 12-16.9 44.7-16.9 44.7-1.8 3.9 0 8.3 3.6 10.1 1 .5 2.1.8 3.1.8 2.9 0 5.7-1.6 6.8-4.4l15.3-31.2L64.8 127c1.3 2.7 3.9 4.3 6.8 4.3z"></path><circle cx="50.3" cy="14.6" r="14.6"></circle></g></svg>';
      btn.dataset.acsbCustomTrigger = "true";

      btnContainerBox.appendChild(btn);
      btnContainer.appendChild(btnContainerBox);
      $footer.appendChild(btnContainer);
    };

    try {
      // if preloader exists on page, wait for preloader before loading the fixed buttons
      const $preloader = document.querySelector('landing-preloader');
      if ($preloader) {
        const $pageContainer = document.querySelector('.page-container');
        if (!$pageContainer.classList.contains('loaded')) {
          document.addEventListener('hero:preloaded', loadAccessibe);
        } else {
          loadAccessibe();
        }
      } else {
        loadAccessibe();
      }
    } catch (e) {
      console.log(e);
    }
  });
})();


